import "../App.css";
import useThemeColor from "../hooks/TopBarColorWheel";
import useContainerHeight from "../hooks/useContainerHeight";

export function PaymentErrorPage() {
  useThemeColor();
  const containerHeight = useContainerHeight();
  return (
    <div className="App" style={{ height: containerHeight - 48 }}>
      <div
        className="App-header"
        style={{ justifyContent: "center", textAlign: "center" }}
      >
        <p className="text-h1">NOE GIKK GALT</p>
        <p className="text-h1 top-margin-m">PRØV IGJEN SENERE</p>
      </div>

      <div className="background"></div>
    </div>
  );
}
